import messages_fr from './translations/fr.json';
import messages_en from './translations/en.json';

export const messages = {
    fr: messages_fr,
    en: messages_en
};

export const submitMessage = {
    submitted: {
        id: 'SurveySubmitted',
        defaultMessage: 'Survey Submitted!'
    }
};
export const language = 'fr'; // language without region code

// export const language = 'en'; // language without region code

// export const language = navigator.language.split(/[-_]/)[0]; // language without region code
